export default __webpack_public_path__ + "static/media/Roboto-Regular.04b605aa.ttf";